import React from "react"
import { BreadcrumbItem, BreadcrumbItemProps } from "./BreadcrumbItem"

import styles from './breadcrumb.module.scss'

export type BreadcrumbProps = {
  breadcrumbs: Array<BreadcrumbItemProps>,
}

export const Breadcrumb = ({
  breadcrumbs,
}: BreadcrumbProps) => {
  return (
    <div className={styles.container}>
      {breadcrumbs.map((item: BreadcrumbItemProps, index: number) => {
        const crumb = { ...item, index }
        return (
          <React.Fragment key={item.label}>
            {index > 0 && <span>&#183;</span>}
            <BreadcrumbItem key={item.label} {...crumb} />
          </React.Fragment>
        )
      })}
    </div>
  )
}